import { Component, Input } from '@angular/core';
import { GridCell } from 'ngrx-data-grid';
import * as R from 'ramda';

@Component({
  template: '{{getObservationTypes() | commaSeparated: [\'description\']}}'
})
export class ObservationTypesColumnComponent implements GridCell<string> {
  @Input() data: string;

  getObservationTypes() {
    return R.prop('observationTypes', this.data);
  }

}
